import Drawer, { DrawerHeader, DrawerBody } from 'common/components/drawer';

import { FormDrawer } from 'common/components/drawer';

import EditWidget from './edit-widget';
import EditVisibility from 'components/drawers/EditCompanyVisibility';

const EditWidgetDrawer = ({ active, drawer, editType }) => {
  return (
    <Drawer layout="table" {...drawer} className={`edit-widget`}>
      <DrawerHeader className="border-bottom pb-4">
        {editType === 'edit' ? `Edit ${active ? active.name : null} Widget` : null}
      </DrawerHeader>
      <DrawerBody className="pt-3 ps-0 pe-0">
        <FormDrawer>
          <EditWidget active={active} drawer={drawer} />
        </FormDrawer>
      </DrawerBody>
    </Drawer>
  );
};

const Form = ({ drawer, active, editType }) => {
  return editType === 'visibility' ? (
    <EditVisibility active={active} drawer={drawer} isOpen={drawer.isOpen} type="widget-types" />
  ) : (
    <EditWidgetDrawer active={active} drawer={drawer} editType={editType} />
  );
};

export default Form;
